<template lang="pug">
  v-card
    .consultants-table__row.consultants-table__row--body
      .consultants-table__column
        span.consultants-table__status(:class="{ 'consultants-table__status--locked': !isActive }") {{ userStatusLabel }}
      .consultants-table__column {{ userTypeLabel }}
      .consultants-table__column {{ item.name | shortstr }}
      .consultants-table__column {{ item.email | shortstr }}
      .consultants-table__column
        span.consultants-table__text {{ item.farm_count }}
        .consultants-table__settings
          settings-consultant-dropdown(
            :id="item.id"
            @edit="modals.showSettingsConsultant = true"
            @change="modals.showChangePasswordConsultant = true"
            @toggled="toggled")
            
          v-dialog(
            max-width="900"
            v-model="modals.showSettingsConsultant")
            settings-consultant-modal(
              :item="item"
              @close="closeModal")
          v-dialog(
            max-width="320"
            v-model="modals.showChangePasswordConsultant")
            change-password-consultant-modal(
              :id="item.id"
              @close="modals.showChangePasswordConsultant = false")

</template>

<script>
import SettingsConsultantDropdown from '../dropdowns/SettingsConsultantDropdown'

import ChangePasswordConsultantModal from '../modals/ChangePasswordConsultantModal'
import SettingsConsultantModal from '../modals/SettingsConsultantModal'

export default {
  name: 'ConsultantsTableRow',

  components: {
    SettingsConsultantDropdown,
    ChangePasswordConsultantModal,
    SettingsConsultantModal
  },

  props: {
    item: Object
  },

  data: () => ({
    modals: {
      showSettingsConsultant: false,
      showChangePasswordConsultant: false
    }
  }),

  computed: {
    isActive () {
      return this.item.is_active
    },
    userStatusLabel () {
      return !this.isActive
        ? this.$t('base.disabled')
        : this.$t('activities.status_active')
    },

    userTypeLabel () {
      return this.item.user_type === 'consultant' &&
            Array.isArray(this.item.permission_groups) &&
            this.item.permission_groups.length
        ? this.$t('activities.consultant_plus')
        : this.item.user_type === 'consultant'
          ? this.$t('activities.consultant')
          : this.$t('activities.staff')
    }
  },
  methods: {
    toggled () {
      this.$emit('update-table')
    },
    closeModal () {
      this.modals.showSettingsConsultant = false
      this.$emit('update-table')
    }
  }
}
</script>
